<template>
  <div>
    <div class="title-bar title-h3">{{ selectDeviceAccountTitle }}</div>
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box mr-t13">
        <!-- 0412 넓이, 간격 조절 -->
        <div style="width:315px; text-align:left">
          <el-button @click="onAddAccountSync" class="mr-r5">계정 동기화</el-button>
          <span v-if="syncStatus">
            <span class="el-icon-loading mr-r4" />
            <span>동기화 중..</span>
          </span>
          <span v-else class="text-regular"
            >마지막 동기화 일시 : <em>{{ getDateFormatter(null, null, recentDatetime) }}</em></span
          >
        </div>
      </div>
      <div class="vertical-center-box mr-t13">
        <el-date-picker
          class="mr-r4"
          style="width: 195px"
          v-model="dateRange"
          :clearable="false"
          :editable="false"
          type="daterange"
          @change="changeDate"
          align="right"
          unlink-panels
          :range-separator="defaultDateRangeOptions.rangeSeparator"
          :start-placeholder="defaultDateRangeOptions.startPlaceholder"
          :end-placeholder="defaultDateRangeOptions.endPlaceholder"
          :picker-options="defaultDateRangeOptions.pickerOptions"
          :default-time="defaultDateRangeOptions.defaultTime"
        >
        </el-date-picker>
        <!-- TODO: 계정 동기화 엑셀 입력 기능 개발 후 주석 제거 -->
        <!-- <el-button class="mr-r4" size="mini" @click="onClickOpenExcelImportPopup">
          <img src="@/assets/img/icons/excel.png" style="position:relative;left:-2px;bottom:2px;">
          <span style="left:2px;bottom:5px;">  엑셀입력</span>
        </el-button> -->
        <el-button class="mr-r4" size="mini" @click="onClickExcelExport">
          <img src="@/assets/img/icons/excel.png" style="position:relative;left:-2px;bottom:2px;" />
          <span style="left:2px;bottom:5px;"> 엑셀출력</span>
        </el-button>
        <el-button class="mr-r4" type="primary" @click="onSaveButton" :disabled="!changeFlag">저장</el-button>
        <el-button class="mr-r4" @click="onResetButton" :disabled="!changeFlag">취소</el-button>
        <w-header-search-button size="mini" @click="setSearchToolVisible"></w-header-search-button>
      </div>
    </el-row>
    <el-table-wrapper
      v-loading="loading"
      :column-default="columnDefault"
      @condition-change="onChangeTable"
      :total="total"
      remote
      ref="settingList"
      slot="body"
      :data="tableData"
      :columns="tableColumn"
      :pagination="true"
      :show-custom-header="true"
      :show-search-tool="showSearchTool"
      style="width:100%;"
    >
      <template slot-scope="scope" slot="management-status">
        <el-switch @change="checkChangeFlag" v-model="scope.row.managementApplyFlag" active-value="Y" inactive-value="N"></el-switch>
      </template>
      <template slot-scope="scope" slot="before-pw">
        <w-user-password-box :target-data="scope.row" @check-change-flag="checkChangeFlag"></w-user-password-box>
      </template>
    </el-table-wrapper>
    <w-add-account-sync-sliding-popup slot="body" ref="addAccountSyncPopup" @get-status-by-sync-hist="getStatusBySyncHist" @load-data="loadData"></w-add-account-sync-sliding-popup>
    <w-import-excel-sync-sliding-popup ref="importExcelSyncPopup" @load-data="loadData" />
  </div>
</template>

<script>
import { isNil, cloneDeep, isEqual, differenceWith, isEmpty } from 'lodash';
import moment from 'moment';
import { columnDefault } from '@/constants/table';
import { getDateToString, defaultDateRangeOptions } from '@/utils/date';
import { EMPTY_TEXT } from '@/utils/string';
import msgUtil from '@/utils/message';
import NetdeviceAccountSettingsAPI from '@/api/settings/netdevice/netdevice-account-settings';
import { getRsaEncryptBulk } from '@/utils/rsa-encrypt';
import { PASSWORD_FOR_VIEW } from '@/constants/common';
import WUserPasswordBox from './UserPasswordBox';
import WImportExcelSyncSlidingPopup from '../popup/ImportExcelSyncSlidingPopup';
import WAddAccountSyncSlidingPopup from '../popup/AddAccountSyncSlidingPopup';

export default {
  name: 'WAccountManagementList',
  components: {
    WUserPasswordBox,
    WAddAccountSyncSlidingPopup,
    WImportExcelSyncSlidingPopup,
  },
  props: {
    selectPhysicalNode: Object,
    NetdeviceAccountSettingsAPI,
  },
  data() {
    const startDatetime = moment()
      .subtract(1, 'month')
      .startOf('day')
      .toDate();
    const endDatetime = moment()
      .endOf('day')
      .toDate();
    return {
      loading: false,
      total: null,
      columnDefault,
      syncStatus: false,
      defaultDateRangeOptions,
      params: {
        objId: '',
        objCompanyId: '',
        startDatetime: Date,
        endDatetime: Date,
      },
      dateRange: [startDatetime, endDatetime],
      changeFlag: false,
      recentDatetime: null,
      showSearchTool: false,
      selectServerTitle: '',
      accountSyncTask: 'accountSyncTask',
      tableDataOrigin: [],
      tableData: [],
      tableColumn: [
        {
          prop: 'managementApplyFlag',
          label: '관리',
          scopedSlot: 'management-status',
          sortable: true,
          remoteProp: 'nda.management_apply_flag',
          width: 60,
        },
        {
          prop: 'objName',
          label: '장비명',
          searchable: true,
          sortable: true,
          remoteProp: 'o.obj_name',
        },
        {
          prop: 'ipaddress',
          label: 'IP주소',
          searchable: true,
          sortable: true,
        },
        {
          prop: 'userId',
          label: '아이디',
          searchable: true,
          sortable: true,
          remoteProp: 'nda.user_id',
        },
        {
          prop: 'beforePw',
          label: '비밀번호',
          formatter: this.passwdConvert,
          scopedSlot: 'before-pw',
        },
        {
          prop: 'syncDatetime',
          label: '동기화일시',
          searchable: true,
          searchType: 'date',
          formatter: this.getDateFormatter,
          remoteProp: 'nda.sync_datetime',
        },
      ],
    };
  },
  computed: {
    selectDeviceAccountTitle() {
      return !isNil(this.selectPhysicalNode) && !isNil(this.selectPhysicalNode.label) && this.selectPhysicalNode.label !== '' ? `[${this.selectPhysicalNode.label}] 계정 관리 목록` : '계정 관리 목록';
    },
  },
  watch: {
    selectPhysicalNode: {
      handler() {
        if (!isNil(this.$refs.settingList)) {
          this.$refs.settingList.clearFilter();
        }
        this.loadData();
      },
      immediate: false,
    },
  },
  beforeDestroy() {
    if (this.$taskManager.existTask(this.executeScriptTask)) {
      this.$taskManager.removeTask(this.executeScriptTask);
    }
  },
  methods: {
    loadData() {
      const tableParams = this.$refs.settingList.getParameter();
      this.params = {
        ...tableParams,
        objId: null,
        objCompanyId: null,
        startDatetime: this.dateRange ? this.dateRange[0].getTime() : null,
        endDatetime: this.dateRange ? this.dateRange[1].getTime() : null,
      };
      if (!isNil(this.selectPhysicalNode) && this.selectPhysicalNode.type !== 'root') {
        if (this.selectPhysicalNode.obj) {
          this.params.objId = this.selectPhysicalNode.obj.objId;
        } else {
          this.params.objCompanyId = this.selectPhysicalNode.objCompanyId;
        }
      }
      // 최근 동기화 시간 초기화
      this.recentDatetime = null;
      this.loading = true;
      NetdeviceAccountSettingsAPI.getDeviceAccountSyncList(this.params)
        .then((res) => {
          const result = res.data;
          if (result.success) {
            this.tableData = result.data.list;
            this.recentDatetime = result.data.recentDatetime;
            this.tableDataOrigin = cloneDeep(this.tableData);
            this.checkChangeFlag();
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '계정', false));
          }
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '계정', false));
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onChangeTable() {
      this.loadData();
    },
    setSearchToolVisible() {
      this.showSearchTool = !this.showSearchTool;
    },
    onClickExcelImport() {
      // 엑셀 import 클릭 시 파일 선택 팝업창 설계 누락 or 기능 제외
    },
    onClickExcelExport() {
      NetdeviceAccountSettingsAPI.exportNetDeviceAccountList(this.params);
    },
    getDateFormatter(row, column, value) {
      if (!isNil(value)) {
        return getDateToString(value);
      }
      return EMPTY_TEXT;
    },
    checkChangeFlag() {
      this.changeFlag = !isEqual(this.tableData, this.tableDataOrigin);
    },
    passwdConvert(row, column, value) {
      return isEmpty(value) ? PASSWORD_FOR_VIEW : value;
    },
    // 리셋 버튼 클릭 이벤트
    onResetButton() {
      this.tableData = cloneDeep(this.tableDataOrigin);
      this.checkChangeFlag();
    },
    onSaveButton() {
      const params = differenceWith(this.tableData, this.tableDataOrigin, isEqual);
      const target = '장비 계정';
      const action = msgUtil.action.SAVE;
      getRsaEncryptBulk(params, ['userPw'])
        .then((encryptData) => {
          NetdeviceAccountSettingsAPI.updateDeviceAccountSyncList(encryptData)
            .then((res) => {
              if (res.data.success) {
                this.loadData();
                this.$message(msgUtil.getResultMsgData(action, target, true));
              } else {
                this.$message(msgUtil.getResultMsgData(action, target, false));
              }
            })
            .catch(() => {
              this.$message(msgUtil.getResultMsgData(action, target, false));
            });
        })
        .catch((e) => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
          throw new Error(e);
        });
    },
    changeDate() {
      this.loadData();
    },
    // 계정 동기화 팝업 생성
    onAddAccountSync() {
      this.$refs.addAccountSyncPopup.open();
    },
    // 이력 시퀀스의 동기화 상태를 가져온다.
    getStatusBySyncHist(histSeq) {
      const param = {
        histSeq,
      };

      this.syncStatus = true;
      this.$taskManager.createTask(
        this.accountSyncTask,
        1,
        () => {
          NetdeviceAccountSettingsAPI.getStatusBySyncHist(param)
            .then((response) => {
              if (response.data.success) {
                if (response.data.data === 'Y') {
                  this.$taskManager.removeTask(this.accountSyncTask);
                  this.syncStatus = false;
                  this.loadData();
                  this.$message(msgUtil.getResultMsgData('완료', '계정 동기화', true));
                } else if (response.data.data === 'N') {
                  this.syncStatus = true;
                }
              } else {
                this.$message(msgUtil.getResultMsgData('완료', '계정 동기화', false));
              }
            })
            .catch(() => {
              this.$message(msgUtil.getResultMsgData('완료', '계정 동기화', false));
            });
        },
        false,
        60,
        () => {
          this.$taskManager.removeTask(this.accountSyncTask);
          this.syncStatus = false;
          this.$message(msgUtil.getCustomResultMsgData('시간초과로 동기화 결과를 확인하지 못하였습니다.', false));
          this.loadData();
        },
      );
      this.$taskManager.startTask(this.accountSyncTask);
    },
    onClickOpenExcelImportPopup() {
      this.$refs.importExcelSyncPopup.open();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/settings/netdevice/DeviceAccountSettings/AccountSynchronization/component/AccountManagementList.vue